<template>
  <div>
    <base-header
      type="gradient-success"
      class="pb-6 pb-8 pt-5 pt-md-8"
    ></base-header>
    <div class="container-fluid mt--7">
      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
          <span class="add__user_cross" @click="$router.go(-1)">&#10006;</span>
          <div class="card bg-secondary shadow border-0">
            <div class="card-body px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <small>Provide User Information</small>
              </div>
              <form role="form">
                <div class="mb-3 p-0">
                  <base-input
                    class="input-group-alternative mb-0"
                    placeholder="First Name"
                    :class="{ 'input-danger': firstNameErr }"
                    addon-left-icon="ni ni-hat-3"
                    @keyup="firstNameErr = false"
                    v-model="model.firstName"
                  >
                  </base-input>
                  <span
                    v-show="firstNameErr"
                    class="text-danger"
                    v-text="firstNameMsg"
                  ></span>
                </div>

                <div class="mb-3 p-0">
                  <base-input
                    class="input-group-alternative mb-0"
                    placeholder="Last Name"
                    :class="{ 'input-danger': lastNameErr }"
                    addon-left-icon="ni ni-hat-3"
                    @keyup="lastNameErr = false"
                    v-model="model.lastName"
                  >
                  </base-input>
                  <span
                    v-show="lastNameErr"
                    class="text-danger"
                    v-text="lastNameMsg"
                  ></span>
                </div>

                <div class="mb-3 p-0">
                  <base-input
                    class="input-group-alternative mb-0"
                    type="email"
                    placeholder="Email"
                    :class="{ 'input-danger': emailErr }"
                    addon-left-icon="ni ni-email-83"
                    @keyup="emailErr = false"
                    v-model="model.email"
                  >
                  </base-input>
                  <span
                    v-show="emailErr"
                    class="text-danger"
                    v-text="emailMsg"
                  ></span>
                </div>

                <div class="mb-3 p-0">
                  <base-input
                    class="input-group-alternative mb-0"
                    placeholder="Password"
                    :class="{ 'input-danger': passwordErr }"
                    type="password"
                    @keyup="passwordErr = false"
                    addon-left-icon="ni ni-lock-circle-open"
                    v-model="model.password"
                  >
                  </base-input>
                  <span
                    v-show="passwordErr"
                    class="text-danger"
                    v-text="passwordMsg"
                  ></span>
                </div>

                <div class="m-0 p-0">
                  <select
                    class="form-control form-control-alternative"
                    aria-describedby="addon-right addon-left"
                    v-model="role"
                    :value="role"
                  >
                    <option
                      v-for="(option, index) in roles"
                      :value="option.value"
                      :key="index"
                    >
                      {{ option.text }}
                    </option>
                  </select>
                </div>

                <div class="text-center">
                  <base-button
                    type="default"
                    class="my-4"
                    @click.prevent="resetForm"
                    >Reset</base-button
                  >
                  <base-button
                    type="success"
                    class="my-4"
                    @click.prevent="register"
                    >Add User</base-button
                  >
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from "@/apiList";
export default {
  name: "users",
  data: function () {
    return {
      users: {
        type: Array,
        default: [],
      },
      role: "Maintainer",
      roles: [
        { text: "Maintainer", value: "maintainer" },
        { text: "Admin", value: "admin" },
      ],
      model: {
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        types: [],
      },
      firstNameErr: false,
      lastNameErr: false,
      emailErr: false,
      passwordErr: false,
      firstNameMsg: "",
      lastNameMsg: "",
      emailMsg: "",
      passwordMsg: "",

      successRes: false,
    };
  },
  methods: {
    async register() {
      if (this.validateForm()) {
        this.$store.dispatch("toggleLoader", true);
        this.firstNameErr = false;
        this.lastNameErr = false;
        this.emailErr = false;
        this.passwordErr = false;
        this.model.types.push({ role: this.role });
        let res = await api.insertUser(this.model);
        console.log("RES: ", res)
        if (!res.response) {
          this.resetForm();
          this.$toast.success(res.data.message);
        } else {
          this.$toast.error(res.response.data.message);
        }
      }
      this.$store.dispatch("toggleLoader", false);
    },
    validateForm() {
      let hasErr = false;
      let instance = this;
      let model_inst = this.model;
      Object.keys(this.model).forEach((elem) => {
        if (!model_inst[elem]) {
          instance[elem + "Err"] = true;
          this[elem + "Msg"] = "This field is required.";
          hasErr = true;
        }
      });
      return !hasErr;
    },
    resetForm() {
      Object.keys(this.model).forEach((elem) => {
        let target = this.model;
        target[elem] = "";
      });
    },
  },
  mounted() {},
};
</script>
<style scoped>
.add__user_cross {
  cursor: pointer;
  position: absolute;
  right: 0 !important;
  top: -12px;
  border: 1px solid #f7fafc;
  background-color: #f7fafc;
  padding: 10px 15px;
  z-index: 9;
  border-radius: 100px;
  color: purple;
}
span.text-danger {
  font-size: 12px !important;
}
.input-danger {
  border: 1px solid red !important;
}
</style>
